import { SVGProps } from '@components/Icon/types';

export const MoreSquareFilled = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM6 11C5.44 11 5 10.55 5 10C5 9.45 5.45 9 6 9C6.55 9 7 9.45 7 10C7 10.55 6.56 11 6 11ZM10 11C9.44 11 9 10.55 9 10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10C11 10.55 10.56 11 10 11ZM14 11C13.44 11 13 10.55 13 10C13 9.45 13.45 9 14 9C14.55 9 15 9.45 15 10C15 10.55 14.56 11 14 11Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'more-square-filled';
